export default {
      id: "icon-quote-usage",
      viewBox: "0 0 62 30",
      url: "/" + "sprite.svg#icon-quote",
      toString: function () {
        return this.url;
      }
    }